import IconMode from "./IconMode";

const IconModeDescription = {
	[IconMode.ALERT]: "Alert Type",
	[IconMode.TIME_DIFFERENCE]: "Time Difference",
	[IconMode.TIME_SINCE_PREVIOUS_UPDATE]: "Time Since Update / Previous Update",
	[IconMode.SPEED]: "Speed",
	[IconMode.VESSEL_TYPE]: "Vessel Type",
	[IconMode.INDEX]: "Index",
	[IconMode.RISK_LEVEL]: "Risk Level (RIM)",

	[IconMode.AVIATION_ALERT]: "Alert Type",
	[IconMode.AVIATION_SIL]: "SIL",
	[IconMode.AVIATION_NACP]: "NAC P"
};
export default IconModeDescription;
